module.exports = __webpack_public_path__ + "img/phpApache.900db83b.png";